import { loginStore } from "@/modules/login/store";
import { accelerationStore } from "@/stores/acceleration";
import { parametersStore } from "@/stores/parameters";

export function isAuthUser() {
  return !loginStore.isGuest && !isLocalServer();
}

export function isVip() {
  return !!accelerationStore.isVip;
}

export function isUseBatch() {
  return !isLocalServer() && isVip();
}

export function isLocalServer() {
  return parametersStore.useLocalServer;
}

export function isNotVipAuthUser() {
  return isAuthUser() && !isVip();
}
